const API = "/api/productos";

export const getProductos = async () => {
    const response = await fetch(API);
    if (!response.ok) throw new Error("Error al obtener productos");
    return await response.json();
};

export const saveProducto = async (producto) => {
    const response = await fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(producto),
    });
    
    if (!response.ok) throw new Error("Error al guardar producto");
    return await response.json();
};

export const deleteProducto = async (id) => {
    // Aseguramos que el parámetro coincida con lo que el backend busca (?id=...)
    const response = await fetch(`${API}?id=${id}`, {
        method: "DELETE",
    });

    if (!response.ok) throw new Error("Error al eliminar producto");
    return true;
};